import { createContext, useContext, type ReactNode } from 'react';
import { type GeoWatchState, useGeoWatch } from './useGeoWatch';

/**
 * US-03482 iPhone black-video RCA, G2 (decided 2026-11-03): ONE position watch for the whole capture. CaptureFlow owns
 * it (`useGeoWatch`) and provides it; the shot screens read it with `useShotGeoWatch`, so a step change neither clears
 * nor re-opens it (each re-open was a new acquisition — a new prompt on Chrome for iOS).
 */
const GeoWatchContext = createContext<GeoWatchState | null>(null);

export function GeoWatchProvider({ watch, children }: { watch: GeoWatchState; children: ReactNode }): JSX.Element {
  return <GeoWatchContext.Provider value={watch}>{children}</GeoWatchContext.Provider>;
}

/** The flow's shared watch; a screen rendered on its own (a test, a standalone screen) watches for itself, as before. */
export function useShotGeoWatch(): GeoWatchState {
  const shared = useContext(GeoWatchContext);
  const own = useGeoWatch(shared === null);
  return shared ?? own;
}
